import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { TIDS } from "@/constants/testIds";
import { Cpu, Workflow, LifeBuoy, Compass, Check } from "lucide-react";

const ICONS = [Cpu, Workflow, LifeBuoy, Compass];

const Services = () => {
  const { t } = useI18n();
  const items = t.servicesDetailed?.items || t.services.items;

  return (
    <section id="services" className="py-20 md:py-32 bg-[#F5F7FA]" data-testid={TIDS.servicesSection}>
      <div className="zdc-container">
        <div className="max-w-2xl mb-12 md:mb-16">
          <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB] mb-3">
            {t.services.eyebrow}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#111111]">
            {t.services.title}
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#6B7280]">{t.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                data-testid={TIDS.serviceCard}
                className="group p-7 md:p-8 bg-white rounded-2xl border border-[#E5E7EB] card-hover hover:border-[#2563EB]/30 hover:shadow-[0_20px_40px_rgba(37,99,235,0.08)]"
              >
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-xl bg-[#F5F7FA] flex items-center justify-center group-hover:bg-[#2563EB] transition-colors flex-shrink-0">
                    <Icon className="w-5 h-5 text-[#111111] group-hover:text-white transition-colors" strokeWidth={1.75} />
                  </div>
                  <div className="space-y-3 flex-1">
                    <h3 className="font-display text-xl font-semibold text-[#111111]">{item.title}</h3>
                    <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">{item.desc}</p>
                    {item.features && (
                      <ul className="pt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1.5">
                        {item.features.map((f, j) => (
                          <li key={j} className="flex items-start gap-1.5 text-xs md:text-[13px] text-[#111111]">
                            <Check className="w-3 h-3 text-[#2563EB] flex-shrink-0 mt-1" strokeWidth={3} />
                            <span>{f}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
